import React, { Component } from "react";
import Severance from "../../../components/Severance/Severance";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : ReportedForm
Description : Componente que invoca al componente Reported, para la creación y consulta de reportados.
Date Autor Modification
================================================================================
1/10/2021 Santiago Coca Rojas Creación – Se llama al componente Reported
================================================================================ */
class SeveranceForm extends Component{
    render(){
        return(
            <Severance/>  
        )   
    }
}

export default SeveranceForm;